import { PageQuery } from "../models/pageQuery";
import { FormFilter } from "../../models/FormFilter";

import { formFilterKeys } from "../consts/formFilterKeys";
import { filterSeparator } from "../consts/queryValueSeparators";

export function parsePageQueryToFormFilter(pq: PageQuery): FormFilter {
    // SSN
    const ssn =
        pq.filterBy.find((x) => x.field === formFilterKeys.ssn)?.value ?? "";

    // Error
    const errorTypes =
        pq.filterBy
            .find((x) => x.field === formFilterKeys.errorType)
            ?.value.split(filterSeparator) ?? [];

    // DocumentId
    const documentId =
        pq.filterBy.find((x) => x.field === formFilterKeys.documentId)?.value ??
        "";

    // Municipalities
    const municipalities =
        pq.filterBy
            .find((x) => x.field === formFilterKeys.municipalities)
            ?.value.split(filterSeparator) ?? [];

    // Status
    const statusTypes =
        pq.filterBy
            .find((x) => x.field === formFilterKeys.statusCode)
            ?.value.split(filterSeparator) ?? [];

    // Period
    let period = undefined;
    const periodFilter = pq.filterBy.find(
        (x) => x.field === formFilterKeys.period
    );
    if (periodFilter) {
        const [from, to] = periodFilter?.value.split(filterSeparator);
        period = {
            start: new Date(from),
            end: new Date(to)
        };
    }

    // Name
    const name = pq?.searchTerm;

    // OnlyFormsWithError
    const onlyFormsWithError =
        pq.filterBy.find((x) => x.field === formFilterKeys.onlyFormsWithError)
            ?.value === "true" ?? false;

    return {
        ssn,
        statusTypes,
        name,
        period,
        errorTypes,
        onlyFormsWithError,
        municipalities,
        documentId
    };
}
